import { observer } from 'mobx-react-lite';
import { FC, MutableRefObject } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { OnboardingPopover } from '@gem/ui-kit';

import { OnboardingType } from 'APP/constants/onboarding';
import { useOnboardingManager } from 'APP/main/hooks/onboardingManager/useOnboardingManager';

interface ISpaceLinkOnboardingProps {
  reference: MutableRefObject<HTMLDivElement | null>;
}

export const SpaceLinkOnboarding: FC<ISpaceLinkOnboardingProps> = observer(({ reference }) => {
  const { t } = useTranslation();
  const presenter = useOnboardingManager(OnboardingType.SpaceLink);

  if (!presenter.isNeedToShow) {
    return null;
  }

  return (
    <OnboardingPopover
      reference={reference}
      description={t('space_onboarding_deep_link')}
      handleClose={presenter.handleClose}
      isOpened={presenter.isOpened}
    />
  );
});
